var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterCollapseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(27.449 -2.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32172",
    "data-name": "Path 32172",
    d: "M25.449,33.685a2.328,2.328,0,0,1-2.328,2.328H6.828A2.328,2.328,0,0,1,4.5,33.685",
    transform: "translate(0 -10.564)",
    fill: "none",
    stroke: "#a7a7a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32173",
    "data-name": "Path 32173",
    d: "M10.5,15l5.819,5.819L22.138,15",
    transform: "translate(-1.345 -2.353)",
    fill: "none",
    stroke: "#a7a7a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32174",
    "data-name": "Path 32174",
    d: "M18,18.466V4.5",
    transform: "translate(-3.025)",
    fill: "none",
    stroke: "#a7a7a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCollapseIcon);
export default __webpack_public_path__ + "static/media/filter-collapse-icon.1ec1d53182db58d04751104cf4c4189c.svg";
export { ForwardRef as ReactComponent };